import { getBrowserTimezone } from '@mi-front/core';
import { useTimezoneCtx } from '../context/timezone.context';

export function useTimezone(): string {
  const ctx = useTimezoneCtx();

  return ctx?.timezone || getBrowserTimezone();
}
